import React from 'react';
import PropTypes from 'prop-types';

/**
 * IneractionArea:
 *    to extend the hitbox(for hover state) of centrifuge between tooltip and centrifuge
 */
export function InteractionArea(props) {
  const onMouseEnter = () => props.setHover(true);
  const onMouseLeave = () => props.setHover(false);

  return (
    <div
      style={{
        height: '68px',
        width: '136px',
        opacity: '0.5',
        position: 'absolute',
        top: '0',
        border: 'none',
        zIndex: 0,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
}

InteractionArea.propTypes = {
  /**
   * callback function to set centrifuge state to hover
   */
  setHover: PropTypes.func,
};
